exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".roomsupport {\n  width: 7.5rem;\n  min-height: 100vh;\n  background-color: #F2F2F2;\n  font-size: 0.28rem;\n  line-height: 0.45rem;\n  color: #383838;\n  padding-bottom: 0.3rem;\n}\n.roomsupport.arlang {\n  direction: rtl;\n  -webkit-direction: rtl;\n  text-align: right;\n}\n.roomsupport .cache {\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/app/roomsupport-op/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/app/roomsupport-op/index.less
// module chunks = 0